import { withStyles } from '@material-ui/core';

import Dropdown from '@/components/Dropdown';

import styles from './styles';

export default withStyles(styles)(Dropdown);
